export const TOAST_PROMPT = 'TOAST_PROMPT';
export const TOAST_REQUIRED = 'TOAST_REQUIRED';

export const promptToast = (promptType, content, options = {}) => ({
  type: TOAST_PROMPT,
  promptType,
  content,
  options,
});

export const requireToastContainer = () => ({
  type: TOAST_REQUIRED,
  required: true,
});
